import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const dataAssetStep = defineStepConfig({
  type: "data_asset",
  name: "Data Asset",
  description:
    "Provides a file from the org-level Data Asset library. Outputs a signed URL and metadata for downstream steps to consume.",
  category: "Data Access",

  inputSchema: z.object({}),

  outputSchema: z.object({
    blobUrl: z.string().describe("Signed URL to download the file content"),
    fileName: z.string().describe("Original file name"),
    contentType: z
      .string()
      .describe("MIME type (e.g. application/json, text/csv)"),
    fileSize: z.number().describe("File size in bytes"),
    containerName: z.string().describe("Storage container name"),
    blobKey: z.string().describe("Blob key/path within the container"),
    versionNumber: z
      .number()
      .describe("Version number of the resolved data asset"),
  }),

  configSchema: z.object({
    dataAssetId: z.string().uuid().describe("ID of the data asset to resolve"),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "1 minute",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "5 seconds",
    },
  },
});
